import React from "react";
import { FormControlLabel, Checkbox, Tooltip } from "@material-ui/core";

const CustomCheckboxField = (props) => {
    const { element, dataObj, onChange, block } = props;
    const key = element.value || element.name;

    const getValueFromPath = (obj, path) => {
        if (!path) return undefined;
        return path.split('.').reduce((acc, k) => acc?.[k], obj);
    };

    const rawValue = getValueFromPath(dataObj, element.value) ?? dataObj[element.name];
    const isChecked = (() => {
        if (rawValue === undefined || rawValue === null) return false;
        if (typeof rawValue === 'boolean') return rawValue;
        if (typeof rawValue === 'string') {
            const lower = rawValue.toLowerCase();
            return !['false', '0', 'no', ''].includes(lower);
        }
        return Boolean(rawValue);
    })();
    const backgroundColor = block?.accordion?.backgroundColor || "#4D9FEC";

    const handleChange = (e) => {
        const newValue = e.target.checked ? 'TRUE' : 'FALSE';
        onChange(key, newValue, element.type);
    };

    const tooltipText = (element.tooltipText != null && element.tooltipText !== '')
        ? element.tooltipText
        : (element.label || '');

    return (
        <div style={{ paddingTop: 18, display: 'flex', alignItems: 'center', minHeight: 32 }}>
            <FormControlLabel
                style={{ fontSize: "12px", marginLeft: 0 }}
                control={
                    <Tooltip
                        title={tooltipText}
                        arrow
                        placement="top"
                        enterDelay={300}
                        disableHoverListener={!tooltipText}
                    >
                        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                            <Checkbox
                                size="small"
                                color="primary"
                                style={{
                                    color: backgroundColor,
                                    padding: "3px",
                                }}
                                checked={isChecked}
                                disabled={element.readOnly}
                                onChange={handleChange}
                            />
                        </span>
                    </Tooltip>
                }
                label={<span style={{ fontSize: "11px" }}>{element.label || ''}</span>}
                labelPlacement="end"
            />
        </div>
    );
};

export default CustomCheckboxField;
